module.exports = __webpack_public_path__ + "static/media/mediumicon.bf8dfba5.svg";